import styled from 'styled-components';

export const TableRow = styled.tr`
  text-align: left;
  
  td:last-child {
    text-align: right;
  }
`;